import type { AlertProps } from "@mui/material";

import type { MomentFormMoment } from "../types/moment-form-moment";
import { getMomentEditStatus } from "./use-moment-edit-status";

type Metadata = {
  title: string;
  heading: string;
  subheading: string;
  level?: AlertProps["severity"];
};

export const useMomentPageMetadata = (moment: MomentFormMoment, newsletter = false): Metadata => {
  const editStatus = getMomentEditStatus(moment);

  const type = newsletter ? "Newsletter" : "Communication";

  const generateSubheading = (): string => {
    switch (moment.status) {
      case "finished":
        return `This ${type} is finished. It has completed all its scheduled sends.`;
      case "draft":
        return `This ${type} is in draft. You can edit it, schedule sends, and publish when you’re ready.`;
      case "active":
        return `This ${type} has been published and has scheduled sends.`;
      case "archived":
        return `This ${type} has been archived.`;
      default:
        return ``;
    }
  };

  switch (editStatus) {
    case "new":
      return {
        title: `Create ${type} | ChangeEngine`,
        heading: `Create ${type}`,
        subheading: "",
      };
    case "draft":
      return {
        title: `${moment.title || "Untitled"} | ChangeEngine`,
        subheading: generateSubheading(),
        heading: moment.title || "Untitled",
      };
    default:
      return {
        title: `${moment.title} | ChangeEngine`,
        heading: moment.title,
        subheading: generateSubheading(),
        level: moment.status === "archived" ? "info" : undefined,
      };
  }
};
